import { Route, RouteProps } from 'react-router-dom';
import { Layout } from 'components';

const PublicRoute = (props: RouteProps) => {
    return (
        <Layout layoutType='error'>
            <Route {...props} />
        </Layout>
    );
}

export default PublicRoute;